<template>
<div v-role="'func'">
<div>
  <br>
  <v-card
    class="mx-auto"
    max-width="1000"
  >
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
   <v-btn to="/painelclasses" class="mx-2" fab dark color="#006699">
      <v-icon dark>arrow_back</v-icon>
    </v-btn>
    <v-card-text>
       <v-container fluid>
           <div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

        <v-row>
          <v-col class="d-flex" cols="12" sm="6" md="6" >
            <p class="display-1 text--primary">
                Confirmação de Matricula
            </p>

          </v-col>
          <v-col class="d-flex" cols="12" sm="6" md="4">
            <p>Quantidade:{{this.estudantes.length}}</p>
          </v-col>
        </v-row>
  </v-container>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <div class="text--primary">

          <v-row>

               <v-col class="d-flex" cols="12" sm="6" md="3">

                <v-autocomplete
                  v-model="editedItem.objecto"
                  :items="estudantes"
                  :loading="isLoading_"
                  :search-input.sync="search"
                  color="primary"
                  item-text="nome"
                  item-value="nome"
                  label="Nome do estudante"
                  placeholder="Digite o nome do estudante"
                  prepend-icon="mdi-database-search"
                  return-object
                  @change="loadTurmaComb"
                ></v-autocomplete>

                </v-col>
                 <v-col class="d-flex" cols="12" sm="6" md="3">
                     <v-combobox
                      v-model="editedItem.classe"
                     item-value="pkAnoacademico"
                    item-text="descricao"
                    required
                    :disabled="disabled"
                    :hint="detalhe"
                    persistent-hint
                    :items="classesFiltered"
                    label="Selecione a classe"
                    @change="loadTurmaClasse"
                  ></v-combobox>
                </v-col>
                 <v-col class="d-flex" cols="12" sm="6" md="3">
                     <v-combobox
                      v-model="editedItem.Turma"
                     item-value="pkTurma"
                    item-text="turmadescricao"
                    :disabled="disabled"
                    required
                    :hint="detalhe"
                    persistent-hint
                    :items="turmasFiltered"
                    label="Selecione a turma"
                  ></v-combobox>
                </v-col>

                 <v-col class="d-flex" cols="12" sm="6" md="2">

                 <v-btn :disabled="editedItem.Turma === null || editedItem.objecto === null || disabled "  color="#006699" text @click="save"  ><v-icon large color="primary" >send</v-icon></v-btn>

             </v-col>
               <v-col class="d-flex" cols="12" sm="6" md="2">
                     <v-progress-circular
                    v-if="progresso"
                    indeterminate
                    color="green"
                ></v-progress-circular>
               </v-col>
          </v-row>
          <v-row>
                 <v-col class="d-flex" cols="12" sm="1" md="1"></v-col>
                 <v-col class="d-flex" cols="12" sm="6" md="3">
                  <p>
                  <v-chip color='primary'> Curso:{{(this.editedItem.objecto !== null)?this.editedItem.objecto.descricao:''}}</v-chip>
                  </p>
                </v-col>
                 <v-col class="d-flex" cols="12" sm="6" md="3">
                  <p>
                  <v-chip> Última classe feita: {{(this.editedItem.objecto !== null)?this.editedItem.objecto.classe:''}}</v-chip>
                  </p>
                </v-col>
               
                <v-col class="d-flex" cols="12" sm="6" md="3">
                  <p>
                   <v-chip>Último anolectivo:{{(this.editedItem.objecto !== null)?this.editedItem.objecto.ControloUltimoParaOproximoAno:''}}</v-chip>
                  </p>
                </v-col>
                 

          </v-row>
      </div>
    </v-form>
    </v-card-text>
  </v-card>
</div>
</div>
</template>
<script>
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')

export default {
  data: () => ({
    items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    estudantes: [],
    turmasAll: [],
    listaDeClassesPorLancarNotas: [],
    turmasFiltered: [],
    valid: true,
    jaMatriculado: '',
    classe: '',
    detalhe: '',
    disabled: false,
    progresso: false,
    isLoading: false,
    isLoading_: false,
    search: null,
    exibe: false,
    acesso: [],
    classesFiltered: [],
    descriptionLimit: 60,
    entries: [],
    classes: [],
    search2: null,
    turma: null,
    filter: false,
    editedItem: {
      objecto: null,
      Turma: null,
      classe: null
    },
    defaultItem: {
      objecto: null,
      Turma: null,
      classe: null
    },
    ruleRequired: [value => value || 'campo obrigatorio']
  }),

  computed: {

    ListaActividades () {
      return ls.get('lista_actividades')
    },
    fields () {
      if (!this.model) return []

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || 'n/a'
        }
      })
    }
  },

  watch: {

    search (val) {
      // Items have already been loaded
    // this.estudantes = []
      // console.log('passouuuuuu' + this.estudantes.length)
      if (val.length > 3) {
      // Items have already been requested
        if (!this.estudantes.filter(t => t.nome.includes(val)).length) {
          this.estudantes = []
        }
        return this.Initialize(val)
      }
    }

  },
  created () {
     this.Initialize()
     this.initializeClasses()
     this.initializeturmasAll()
    // this.turmaFindWithEstudanteCount()
  },

  methods: {

    async Initialize (searchDB) {
      this.isLoading = true
      this.isLoading_ = true
      if (!this.estudantes.length) {
        if (searchDB) {
          var payload = '{ "find" : "' + searchDB + '" }'
        } else {
          payload = '{ "find":"all" }'
        }
        try {
          // this.isLoading = true
          this.estudantes = await axios
            .get('/EstudantesConfirmacao/' + payload)
            .then(res => res.data)
          this.isLoading = false
          this.isLoading_ = false
        } catch (error) {
          this.isLoading = false
          this.isLoading_ = fals
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
      this.isLoading = false
      this.isLoading_ = false
    },

    ListarEstudantes (item) {
      this.$store.state.objturma = item
      this.$router.push('ListaAlunos')
    },

    async save () {
      if ((this.$refs.form.validate())) {
        this.progresso = true
        let params =
              { 
                autor: ls.get('nomeUsuario'),
                turma_id: this.editedItem.Turma.id,
                turmaDescricao: this.editedItem.Turma.turmadescricao,
                curso: this.editedItem.Turma.descricao,
                classe: this.editedItem.classe.descricao,
                estudante_id: this.editedItem.objecto.pk_estudante

              }
        try {
          let msg = await axios
            .post('/confirmarMatricula-Fin', params)
            .then(res => res.data)
          if(msg.affectedRows >= 1){
            this.progresso = false
              Swal.fire({
                    title: 'Informação',
                    text: "Confirmação feita com sucesso!",
                    icon: 'success',
                    showCancelButton: true,
                    cancelButtonText:'Fechar',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ir em pagamentos ?',
                    reverseButtons:true,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.$router.push('esc-pagamento')
                    }
                  })
              this.Limpar()
          }else{
              utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação');
          }
          
        } catch (error) {
          this.progresso = false
          utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação');
        }
      }
    },

    Limpar () {
        this.editedItem.objecto = null
        this.editedItem.Turma = null
        this.editedItem.classe = null
    },

    async initializeturmasAll () {
      try {
        // this.isLoading = true
        this.turmasAll = await axios
          .get('/turmasFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async turmaFindWithEstudanteCount () {
      try {
        this.listaDeClassesPorLancarNotas = await axios
          .get('/turmaFindWithEstudanteCount/' + 'all') // idclasse JyUn JQ==
          .then(res => res.data)
          console.log(this.listaDeClassesPorLancarNotas);
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },

    async verificaSeJaConfirmado(){
       try {
        return  await axios
          .post('/Estudante-ja-Confirmado', this.editedItem.objecto)  
          .then(res => res.data)
       } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initializeClasses () {
      try {
        this.isLoading = true
        this.classes = await axios.get('/anoacademicoFindAll').then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }finally{this.isLoading = false}
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },
    async loadTurmaComb () { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.classesFiltered = this.classes.filter( c=> c.nivel === this.editedItem.objecto.nivel_ensino)
      let result  = await this.verificaSeJaConfirmado().then()
      if( result.qtd  <= 0 ){
        this.disabled = false
      }else{ // Já tem a matrícula ou confirmação feita neste anolectivo
        //this.disabled = true
        this.$store.dispatch('textMessage', {msg: 'Estudante já confirmado no anolectivo actual',classMessage: 'msgError',timeout: 8000})
      }
    },

    loadTurmaClasse () {
       this.turmasFiltered = this.turmasAll.filter( t=> t.curso_id ===  this.editedItem.objecto.idCurso && t.classe_id === this.editedItem.classe.pkAnoacademico)
    }

  }
}
</script>
